/* eslint-disable react/prop-types */
import React from "react";
import Fade from "react-awesome-reveal";

import CEO from "../assets/images/TeamMembers/CEO.jpg";
import HRD from "../assets/images/TeamMembers/HRD.jpg";
import Finance from "../assets/images/TeamMembers/Finance.jpg";
import ProjectManager from "../assets/images/TeamMembers/Project-manager.jpg";
import Frontend1 from "../assets/images/TeamMembers/Frontend1.jpg";
import Backend1 from "../assets/images/TeamMembers/Backend1.jpg";
import Mobile1 from "../assets/images/TeamMembers/Mobile1.jpg";
import UIUX1 from "../assets/images/TeamMembers/UIUX1.jpg";

// Reusable card component
const TreeCard = ({ name, position, imageUrl }) => (
  <Fade triggerOnce direction="up">
    <div className="bg-white border-2 border-blue-500 rounded-2xl shadow-lg p-4 w-48 sm:w-56 text-center hover:scale-105 transform transition duration-300 z-10">
      <img
        src={imageUrl}
        alt={name}
        className="w-24 h-24 rounded-full mx-auto mb-3 object-cover"
      />
      <h2 className="text-blue-600 text-lg font-semibold">{name}</h2>
      <p className="text-sm text-gray-500">{position}</p>
    </div>
  </Fade>
);

// Department data with one child each
const departments = [
  {
    name: "Marta Kebede",
    position: "Operation Dept.",
    image: HRD,
    child: {
      name: "Lulit Kidane",
      image: UIUX1,
    },
  },
  {
    name: "Liya Fikru",
    position: "Finance Dept.",
    image: Finance,
    child: {
      name: "Tewodros Abera",
      image: Mobile1,
    },
  },
  {
    name: "Samuel Gebru",
    position: "Marketing Dept.",
    image: Frontend1,
    child: {
      name: "Binyam Terefe",
      image: Backend1,
    },
  },
  {
    name: "Nahom Tesfaye",
    position: "Admin Dept.",
    image: ProjectManager,
    child: {
      name: "John Dawit",
      image: Frontend1,
    },
  },
];

export default function AllTeam2() {
  return (
    <section className="container mx-auto px-4 py-10">
      <div className="flex flex-col items-center space-y-10">
        {/* CEO and Secretary layout */}
        <div className="relative flex justify-center items-start w-full">
          {/* CEO centered */}
          <div className="flex flex-col items-center z-10">
            <TreeCard
              name="Abebe Bekele"
              position="General Manager"
              imageUrl={CEO}
            />
            {/* Vertical line below CEO */}
            <div className="h-16 w-1 bg-gray-500 mt-2"></div>
          </div>

          {/* Secretary positioned to the right */}
          <div className="absolute top-0 right-10 flex flex-col items-center z-10">
            <TreeCard
              name="Melat Tesfaye"
              position="Secretary"
              imageUrl={UIUX1}
            />
          </div>

          {/* Dotted line between CEO and Secretary */}
          <div className="absolute top-16 left-[55%] w-[320px] border-t-4 border-dotted border-gray-400 z-0"></div>
        </div>

        {/* Horizontal line connecting to departments */}
        <div className="relative w-0 h-0">
          <div className="absolute h-1 w-[800px] bg-gray-400 top-0 left-[-400px]"></div>
        </div>

        {/* Departments and their child team members */}
        <div className="flex justify-center gap-10 flex-wrap mt-0">
          {departments.map((dept, idx) => (
            <div key={idx} className="flex flex-col items-center">
              {/* Line from horizontal bar to department */}
              <div className="h-10 w-1 bg-gray-400 mb-2"></div>
              <TreeCard
                name={dept.name}
                position={dept.position}
                imageUrl={dept.image}
              />
              {/* Line to child */}
              <div className="h-10 w-1 bg-gray-400 mt-0 mb-2"></div>
              <TreeCard
                name={dept.child.name}
                position={dept.child.position || "Staff"}
                imageUrl={dept.child.image}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
